import React, { useEffect, createElement } from 'react';
export const MetaPixel = () => {
  useEffect(() => {
    // Create script element
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s) {
        if(f.fbq)return;n=f.fbq=function(){n.callMethod? 
        n.callMethod.apply(n,arguments):n.queue.push(arguments)}; 
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0'; 
        n.queue=[];t=b.createElement(e);t.async=!0; 
        t.src=v;s=b.getElementsByTagName(e)[0]; 
        s.parentNode.insertBefore(t,s)
      }(window, document,'script', 'https://connect.facebook.net/en_US/fbevents.js'); 
      fbq('init', '527906828002058'); 
      fbq('track', 'PageView');
    `;
    // Create noscript element
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1596463344592597&ev=PageView&noscript=1';
    noscript.appendChild(img);
    // Add elements to head
    document.head.appendChild(script);
    document.head.appendChild(noscript);
    // Clean up on unmount
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(noscript);
    };
  }, []);
  return null;
};